import {
  // -- GET (list)
  GET_GLOBAL_VARIABLES_SUCCESS,
  GET_GLOBAL_VARIABLES_FAILURE,
  // -- DELETE
  DELETE_GLOBAL_VARIABLE_SUCCESS,
  DELETE_GLOBAL_VARIABLE_FAILURE,
  // -- CREATE
  CREATE_GLOBAL_VARIABLE_SUCCESS,
  CREATE_GLOBAL_VARIABLE_FAILURE,
  // -- UPDATE
  UPDATE_GLOBAL_VARIABLE_SUCCESS,
  UPDATE_GLOBAL_VARIABLE_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const globalVariables = (state = {}, action) => {
  switch (action.type) {
    // -- GET_GLOBAL_VARIABLES
    case GET_GLOBAL_VARIABLES_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalVariables.GET_GLOBAL_VARIABLES_FAILURE()')
      return { ...state, error: action.data }
    }
    case GET_GLOBAL_VARIABLES_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalVariables.GET_GLOBAL_VARIABLES_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE_GLOBAL_VARIABLE
    case CREATE_GLOBAL_VARIABLE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalVariables.CREATE_GLOBAL_VARIABLE_FAILURE()')
      return { ...state, error: action.data }
    }
    case CREATE_GLOBAL_VARIABLE_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalVariables.CREATE_GLOBAL_VARIABLE_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE_GLOBAL_VARIABLE
    case UPDATE_GLOBAL_VARIABLE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalVariables.UPDATE_GLOBAL_VARIABLE_FAILURE()')
      return { ...state, error: action.data }
    }
    case UPDATE_GLOBAL_VARIABLE_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalVariables.UPDATE_GLOBAL_VARIABLE_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- DELETE_GLOBAL_VARIABLE
    case DELETE_GLOBAL_VARIABLE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalVariables.DELETE_GLOBAL_VARIABLE_FAILURE()')
      return { ...state, error: action.data }
    }
    case DELETE_GLOBAL_VARIABLE_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalVariables.DELETE_GLOBAL_VARIABLE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    default:
      return state
  }
}
